module.exports = __webpack_public_path__ + "img/gfit1.d376feba.jpg";